// extracted by mini-css-extract-plugin
export default {"dandd":"DragandDrop_dandd__xnfez","onHover":"DragandDrop_onHover__Vnq11"};